<template>
  <base-step :title="trans('guided_search.user.title')" main-class="user-step-container">
    <template #content>
      <div class="user-step-container__inputs">
        <span>
          <input
            v-model="fullName.value"
            type="text"
            name="user-name"
            autocomplete="name"
            :disabled="fullName.isDisabled"
            :class="{ 'error': fullName.touched && isUserNameInvalid }"
            :placeholder="trans('guided_search.placeholder.user.name')"
            @input="sendUserStore('fullName', fullName.value)"
            @blur="fullName.touched = true"
          >
          <label v-if="fullName.touched && isUserNameInvalid">{{ trans('global.form.field.invalid', { field: trans('guided_search.placeholder.user.name') }) }}</label>
        </span>
        <span>
          <input
            v-model="organization.value"
            type="text"
            name="organization"
            :disabled="organization.isDisabled"
            :class="{ 'error': organization.touched && isOrganizationDisabled }"
            :placeholder="trans('guided_search.organization.field')"
            @input="sendOrganizationStore(organization.value)"
            @blur="organization.touched = true"
          >
          <label v-if="organization.touched && isOrganizationDisabled">{{ trans('global.form.field.invalid', { field: trans('guided_search.organization.field') }) }}</label>
        </span>
        <span>
          <input
            v-model="email.value"
            type="email"
            name="user-mail"
            autocomplete="email"
            :disabled="email.isDisabled"
            :class="{ 'error': email.touched && !isUserEmailValid }"
            :placeholder="trans('guided_search.placeholder.user.mail')"
            @input="sendUserStore('email', email.value)"
            @blur="email.touched = true"
          >
          <label v-if="email.touched && !isUserEmailValid">{{ trans('global.form.field.invalid', { field: trans('guided_search.placeholder.user.mail') }) }}</label>
        </span>
        <span>
          <PhoneInput
            v-model="phoneNumber.value"
            :class="{ 'error': phoneNumber.touched && !isValid }"
            :disabled="phoneNumber.isDisabled"
            @blur="phoneNumber.touched = true"
          />

          <label v-if="phoneNumber.touched && !isValid">{{ trans('global.form.field.invalid', { field: trans('guided_search.placeholder.user.phone') }) }}</label>
        </span>
      </div>
    </template>
  </base-step>
</template>

<script>
import PhoneNumber from '@tools/phoneNumber';
import PhoneInput from '@components/PhoneInput.vue';
import translation from '@elements/translation';
import guidedSearchMixin from '../guidedSearchMixin';
import BaseStep from './BaseStep.vue';

export default {
  name: 'User',
  components: {
    PhoneInput,
    BaseStep,
  },
  mixins: [ guidedSearchMixin, translation ],
  props: {
    defaultPhoneNumber: { type: String, default: '' },
  },
  data() {
    return {
      previousDefaultCode: null,
      fullName: {
        value: null,
        touched: false,
        isDisabled: false,
      },
      email: {
        value: null,
        touched: false,
        isDisabled: false,
      },
      phoneNumber: {
        value: new PhoneNumber(this.defaultPhoneNumber),
        touched: false,
        isDisabled: false,
      },
      organization: {
        value: null,
        touched: false,
        isDisabled: false,
      },
      phoneInputOptions: {
        placeholder: this.trans('guided_search.placeholder.user.phone'),
        maxlength: 10,
      },
      phoneTranslations: {
        countrySelectorLabel: this.trans('guided_search.placeholder.user.phone.country_selector_label'),
        countrySelectorError: this.trans('guided_search.placeholder.user.phone.country_selector_error'),
        phoneNumberLabel: this.trans('guided_search.placeholder.user.phone.phone_number_label'),
        example: this.trans('guided_search.placeholder.user.phone.example'),
      },
      selectedCountryCode: null,
      isValid: false,
    };
  },
  computed: {
    getUserValues() {
      return this.$store.getters['formGuidedSearch/getStepValue']('user');
    },
  },
  watch: {
    phoneNumber: {
      deep: true,
      handler(phoneNumber) {
        this.isValid = phoneNumber.value.isValid;
        this.sendUserStore('phoneNumber', phoneNumber.value.international);
        this.sendUserStore('phoneNumberIsValid', this.isValid);
      },
    },
  },
  mounted() {
    const user = this.getUserValues;
    this.fullName.value = user.fullName;
    this.email.value = user.email;
    this.organization.value = this.$store.getters['formGuidedSearch/getStepValue']('organization');

    const infosData = this.getUserDefaultInfosData;

    if (infosData?.fullname) {
      this.fullName.value = infosData.fullname;
      this.fullName.isDisabled = true;
      this.sendUserStore('fullName', this.fullName.value);
    }

    if (infosData?.email) {
      this.email.value = infosData.email;
      this.email.isDisabled = true;
      this.sendUserStore('email', this.email.value);
    }

    if (infosData?.phone) {
      this.phoneNumber.isDisabled = true;
      this.phoneNumber.value = new PhoneNumber(infosData.phone);
      this.sendUserStore('phoneNumber', this.phoneNumber.value.international);
      this.sendUserStore('phoneNumberIsValid', true);
    }

    if (infosData?.organization) {
      this.organization.value = infosData.organization;
      this.organization.isDisabled = true;
      this.sendOrganizationStore(this.organization.value);
    }

    window.dataLayer.push({
      event: 'screenChange',
      event_name: 'infos',
      step: 'infos',
      funnel: 'support-contact-form',
    });
  },
  methods: {
    sendUserStore(detailField, value) {
      this.$store.commit(
        'formGuidedSearch/SET_STEP_VALUE',
        { step: 'user', stepDetails: detailField, value },
      );
    },
    sendOrganizationStore(value) {
      this.$store.commit(
        'formGuidedSearch/SET_STEP_VALUE',
        { step: 'organization', value },
      );
    },
  },
};
</script>
